module.exports = __webpack_public_path__ + "img/album07_30.793ce0c4.jpg";